import type { MouseEvent } from "react";

// Bấm cả dòng để mở chi tiết. Bỏ qua khi bấm vào control trong dòng (checkbox, nút ⋯, link, nút),
// khi bấm trong menu thả xuống (portal nằm ngoài dòng nhưng sự kiện React vẫn nổi bọt lên dòng),
// và khi đang bôi đen chữ để copy.
export function openOnRowClick(open: () => void) {
  return {
    onClick: (event: MouseEvent<HTMLElement>) => {
      const target = event.target as HTMLElement;
      if (!event.currentTarget.contains(target)) return;
      if (target.closest("button, a, input, label, .text-link, .ant-dropdown-trigger, .ant-table-selection-column")) return;
      if (window.getSelection()?.toString()) return;
      open();
    },
    style: { cursor: "pointer" },
  };
}
